import jsPDF from "jspdf";
import autoTable, { RowInput } from 'jspdf-autotable';
import { DatePipe, DecimalPipe } from '@angular/common';
// import { NgxNumToWordsService, SUPPORTED_LANGUAGE } from 'ngx-num-to-words';


export class Pdf {

     // convertir numero a letra
    numberInWords!: string;
    // lang: SUPPORTED_LANGUAGE = 'es';
 
    private _margin = { left: 12, right: 12, top: 20, bottom: 25 };
    private _spacing = 5;

    private _doc: jsPDF;
    private _datePipe: DatePipe;
    private _decimalPipe: DecimalPipe;

    // en cuantas columnas dividimos la pagina, por defecto 1 columna
    private _pageColumn: number = 1

    // objeto a cargar con la cabecera y detalle
    private _data: IData = { headers: [], source: [] };
    private _title: string;
    private _cabecera: Record<string, any>[];
    private _currentUser: any;

    private _titleFontSize = 10;
    private _fontSize = 8;
    private _textColorBlack: any = [0, 0, 0];
    private _textColorWhite: any = [255, 255, 255];
    private _fillColorCyan: any = [0, 191, 191];
    private _fillColorWhite: any = [250, 250, 250];
    private _fillColorGray: any = [240, 240, 240];

    constructor( currentUser: any, orientacion: any = 'p') {
        const pdfOrientacion: "p" | "portrait" | "l" | "landscape" = orientacion;
        this._currentUser = currentUser;
        this._doc = new jsPDF(pdfOrientacion, 'px', 'a4', true);
        // console.log(this._currentUser);
        this._datePipe = new DatePipe('es-PY');
        this._decimalPipe = new DecimalPipe('es-PY');
    }

    public get doc() { return this._doc };

    public set title( title: string ) { this._title = title };

    public set pageColumn( pageColumn: number ) { this._pageColumn = pageColumn };

    public set headers( headers: IHeader[] ) { this._data.headers = headers }

    public set source( source: ISource[] ) { this._data.source = source}

    public set foot( foot: Record<string, any> ) { this._data.foot = foot }

    public set fontSize( fontSize: number ) { this._fontSize = fontSize }

    public async addSource( source: ISource ) {
        this._data.source.push( source );
    }

    private async getPreviousAutotable() {
        return (this._doc as any).previousAutoTable;
    }

    // encavenzado con el nombre de la empresa y sucursal
    private async setHeader() {
        const content = `${String(this._currentUser.nombre_empresa).toUpperCase()} - ${String(this._currentUser.nombre_sucursal).toUpperCase()}`
        autoTable(this._doc, {
            margin: this._margin,
            head: [
                [{
                    content: content,
                    colSpan: this._cabecera?.length ? this._cabecera.length : 6,
                    styles: { halign: 'center', fillColor: this._fillColorWhite, textColor: this._textColorBlack, fontSize: this._titleFontSize },
                }],
            ],
            showHead: 'firstPage',
            theme: 'plain',
            startY: 15,
            styles: { fontSize: this._fontSize }
        })
    }
    
    // titulo del reporte
    private async setTitle() {
        autoTable(this._doc, {
            margin: this._margin,
            head: [
                [{
                    content: this._title.toUpperCase(),
                    colSpan: this._cabecera?.length ? this._cabecera.length : 6,
                    styles: { halign: 'center', fillColor: this._fillColorCyan, textColor: this._textColorWhite, fontSize: this._titleFontSize }
                }]
            ],
            showHead: 'firstPage',
            theme: 'plain',
            startY: 30,
            styles: { fontSize: this._fontSize }
        })
    }

    private async getWidth() {
        return this._doc.internal.pageSize.getWidth() / this._pageColumn;
    }

    // cabecera del reporte
    private async getHeader( headers?: IHeader[] ): Promise<RowInput> {
        let dataHeaders = this._data.headers;
        if ( headers ) { dataHeaders = headers };
        const header = [];
        for (const head of dataHeaders ) {
            header.push({ content: head.label.toUpperCase(), styles: { halign: 'center', fillColor: this._fillColorGray, textColor: this._textColorBlack, fontSize: this._fontSize - 2 }})
        }
        return header;
    }

    private async getFootHeader( headers?: IHeader[] ): Promise<RowInput> {
        const dataHeaders = headers;
        const header = [];
        for (const head of dataHeaders ) {
            header.push({ content: head.label.toUpperCase(), styles: { halign: 'center', fillColor: this._fillColorGray, textColor: this._textColorBlack, fontSize: this._fontSize - 2 }})
        }
        return header;
    }

    // cuerpo del reporte
    private async getBody( data: Record<string, any>, headers?: IHeader[] ): Promise<RowInput> {
        let dataHeaders = this._data.headers;
        if ( headers ){ dataHeaders = headers }
        const row = [];
        for (const head of dataHeaders ) {
            switch (head.type) {
                case 'text':
                    row.push(data[head.name])
                    break;
                case 'number':
                    row.push({ content: this._decimalPipe.transform( data[head.name] ), styles: { halign: 'right', fontStyle: 'bold' } });
                    break;
                case 'date':
                    row.push( this._datePipe.transform( data[head.name], 'dd/MM/yyyy' ));
                    break;
                case 'datetime':
                    row.push( this._datePipe.transform( data[head.name], 'dd/MM/yyyy hh:mm:ss' ));
                    break;
                case 'boolean':
                    if ( data[head.name] === true ) {
                        row.push({ content: 'SI', styles: { halign: 'center' } })
                    } else {
                        row.push({ content: 'NO', styles: { halign: 'center' } })
                    }
                    break;
                default:
                    break;
            }
        }
        return row;
    }

    public async exportar() {
        await this.setHeader();
        // Titulo
        await this.setTitle();
        const body = []
        let withDetail = false;
        for (const source of this._data.source) {
            if ( source.items ) {
                withDetail = true
                // CABECERA
                autoTable( this._doc, {
                    margin: this._margin,
                    theme: 'grid',
                    head: [ await this.getHeader() ],
                    body: [ await this.getBody( source.data ) ],
                    bodyStyles: { fontSize: this._fontSize - 1 },
                    showHead: 'everyPage'
                });
                // DETALLE
                const items = [];
                for (const item of source.items.source ) {
                    items.push( await this.getBody( item, source.items.headers ) )
                }
                autoTable( this._doc, {
                    margin: { left: this._margin.left + this._spacing, right: this._margin.right + this._spacing, top: this._margin.top, bottom: this._margin.bottom },
                    theme: 'grid',
                    head: [ await this.getHeader( source.items.headers ) ],
                    body: items,
                    bodyStyles: { fontSize: this._fontSize - 1 },
                    showHead: 'everyPage',
                    startY: (await this.getPreviousAutotable()).finalY + 1
                });
                // SUMATORIA AL FINAL DEL DETALLE
                if ( source.items.foot && this._data.source.length > 1 ) {
                    autoTable( this._doc, {
                        margin: { left: this._margin.left + this._spacing, right: this._margin.right + this._spacing, top: this._margin.top, bottom: this._margin.bottom },
                        theme: 'grid',
                        head: [ await this.getFootHeader( source.items.foot.headers ) ],
                        body: [ await this.getBody( source.items.foot.source, source.items.foot.headers ) ],
                        bodyStyles: { fontSize: this._fontSize, fontStyle: "bold" },
                        startY: (await this.getPreviousAutotable()).finalY + 1.5
                        // showHead: ''
                    });
                }
            } else {
                body.push( await this.getBody( source.data ) )
            }
        }
        if ( !withDetail ) {
            autoTable( this._doc, {
                margin: this._margin,
                theme: 'grid',
                head: [ await this.getHeader() ],
                body: body,
                bodyStyles: { fontSize: this._fontSize - 1 },
                showHead: 'everyPage'
            });
        }

        // TOTAL GENERAL AL FINAL DEL DOCUMENTO
        if ( this._data.foot ) {
            autoTable( this._doc, {
                margin: this._margin,
                theme: 'grid',
                head: [ await this.getFootHeader( this._data.foot.headers ) ],
                body: [ await this.getBody( this._data.foot.source, this._data.foot.headers ) ],
                bodyStyles: { fontSize: this._fontSize, fontStyle: "bold" },
                // showHead: ''
            });
        }

        const pagesQty = this._doc.getNumberOfPages();
        const positiony = this._doc.internal.pageSize.getHeight();
        const positionx = this._doc.internal.pageSize.getWidth();

        for (let i = 1; i <= pagesQty; i++) {
            this._doc.setPage(i);
            this._doc.setFontSize(9);
            this._doc.text(`${this._datePipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss')} - ${ this._currentUser.nombre }`, this._margin.left, positiony - 12, {align: 'left'});
            this._doc.text(`Pag. ${i.toString()}/${pagesQty}`, positionx - this._margin.left, positiony - 12, {align: 'right'});
        }
        window.open(URL.createObjectURL(this._doc.output('blob')));
    }


    public async imprimirPagare( operacion: any ) {   
        // algunas constantes                
        // const serviceToWord = new NgxNumToWordsService();
        // const montoLetra =  serviceToWord.inWords(operacion.importe_total, this.lang).toUpperCase();
        const montoLetra =  ''
        const inicioX = 38;
        const finX = 430;
        const indice = operacion.cuotas.length - 1;
        const fechaActual = new Date();
        const fechaVencida = new Date(operacion.cuotas[indice].fecha_vencimiento);
        this._doc.setFontSize(22);
        this._doc.setFont("Times New Roman", "bold")
        this._doc.text('PAGARE A LA ORDEN', 148, 88);        
        autoTable( this._doc, {
            startY: 100,
            head: [['VENCIMIENTO', 'PAGARÉ']],
            body: [
                [`${ this._datePipe.transform( fechaVencida, 'dd')} / ${ this._datePipe.transform(fechaVencida, 'MM')} / ${this._datePipe.transform(fechaVencida,'YYYY')}`, '        ']
            ],
            headStyles: { font: "times", fontStyle: "bold", fontSize: 8, minCellWidth: 3, halign: 'center'},
            bodyStyles: { cellPadding: 1, minCellHeight: 2, fontSize: 8, halign: 'center'},
            theme: 'plain',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
            },

            margin:  { left: 35, right: 10, top: 15, bottom: 10 },
            tableWidth: 115,
        });
        const totalFormateado = operacion.importe_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        autoTable( this._doc, {
            startY: 100,
            head: [[`Gs. ${totalFormateado } ` ]],
            headStyles: { font: "times", fontStyle: "bold", fontSize: 14, cellPadding: 4, halign: 'left', minCellHeight: 20},
            theme: 'plain',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
            },
            margin:  { left: 310, right: 10, top: 15, bottom: 5 },
            tableWidth: 120,
        });
        
        this._doc.setFontSize(14.5);
        this._doc.text(`Asunción,  ${ this._datePipe.transform(fechaActual,'dd')}  de  ${this._datePipe.transform(fechaActual, 'MMMM')}  del 20${this._datePipe.transform(fechaActual, 'YY')}`, 258, 143);
        this._doc.setFontSize(9.2);
        this._doc.setFont("helvetica", "normal")
        const direccion = `  domicilio de ésta, sito en  ${operacion.direccion_entidad}, de la ciudad de ${operacion.ciudad};la suma de`
        let yPosition = 168; // Posición Y inicial
        const  text = `El día  ${this._datePipe.transform(fechaActual,'dd') }  de   ${this._datePipe.transform(fechaActual, 'MMMM')}  del 20${this._datePipe.transform(fechaActual, 'YY')}, pagaré/mos a la orden de `;
        const textolargo = `Por  igual valor recibido en mutuo .......………………………………………………………………….………………………. a mi (nuestra) entera satisfacción. Si  este  pagaré a la  orden, no es  abonado  a  su   vencimiento,   devengará   un   interés   moratorio   del   ${operacion.porcentaje_moratorio}% mensual, más una comisión de …...% mensual, desde la fecha de su vencimiento, hasta el día de su pago en efectivo. En caso  de retraso o  incumplimiento  total o  parcial,  desde  la  fecha  de su  vencimiento,  quedará  constituida  la mora automáticamente, sin necesidad de interpelación judicial o extrajudicial alguna y hará decaer de pleno derecho los plazos de las cuotas no  vencidas;  en cuyo caso`;        
        this._doc.text( text, inicioX , yPosition);
        let fontSize = this._doc.getFontSize();
        let textWidth = this.calcularTamanho(text, fontSize, inicioX);
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8.2);
        this._doc.text(` ${operacion.nombre_entidad}`, textWidth, yPosition);
        this._doc.setFont("helvetica", "normal");
        this._doc.setFontSize(9.1);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho(operacion.nombre_entidad, fontSize, textWidth );
        this._doc.text(' en el',  textWidth , yPosition);
        textWidth = this.calcularTamanho( 'en el ', fontSize, textWidth );        
        // proceso de enviar a bajo cuando toca el limite
        const lineHeight = 10; // Altura de línea
        let lines = this._doc.splitTextToSize(direccion, finX - textWidth); 
        const partes = direccion.split(lines[0]);
        const direccionParte = partes[1].trim();
        this._doc.text(lines[0], textWidth, yPosition);                
        this._doc.text(direccionParte, inicioX, yPosition + 10);                
        textWidth = this.calcularTamanho( direccionParte, fontSize, inicioX );        
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8.8);
        this._doc.text('   guaraníes:', textWidth, yPosition + 10);
        autoTable( this._doc, {
            startY: 188,
            head: [[`${montoLetra}`]],
            headStyles: {  cellPadding: 4, minCellHeight: 20, valign: 'middle'},
            theme: 'plain',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
            },
            margin:  { left: inicioX , right: 410, top: 15, bottom: 5 },
            tableWidth: 395,
        });
        this._doc.setFont("helvetica", "normal");
        this._doc.setFontSize(9);
        fontSize = this._doc.getFontSize();
        lines = this._doc.splitTextToSize(textolargo, finX - inicioX); 
        let cont = 0;
        yPosition = 216;
        for(const line of lines) {
            this._doc.text(line, inicioX, yPosition);            
            textWidth = this.calcularTamanho(line, fontSize, inicioX);
            yPosition += lineHeight; 
        }
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8.2);
        this._doc.text(`  ${operacion.nombre_entidad}   `, textWidth, yPosition -10 );
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho(operacion.nombre_entidad, fontSize, textWidth);
        this._doc.setFont("helvetica", "normal");
        this._doc.setFontSize(9);
        this._doc.text('   podrá exigir el pago total del saldo adeudado-------------------------------------' , textWidth, yPosition - 10 );
        this._doc.text('Por  otra  parte  y  en  forma irrevocable les autorizo, para que en caso de un atraso superior a los noventa (90) días en el pago del' , inicioX, 276);
        let textP = 'presente  crédito  o  de  cualquier otra deuda pendiente que mantenga/ mos con';
        this._doc.text(textP , inicioX, 286);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho(textP , fontSize, inicioX);
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8.2);
        this._doc.text(`  ${operacion.nombre_entidad};`, textWidth, 286);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho(`  ${operacion.nombre_entidad} ;`, fontSize, textWidth);
        this._doc.setFont("helvetica", "normal");
        this._doc.setFontSize(9);
        fontSize = this._doc.getFontSize();
        const textoLargo = ` incluyan  mi/nuestro nombre o Razón Social que represento/tamos, en el Registro General de morosos de la firma Informconf, o de cualquier otra  empresa  de  actividad similar  que  opere  en  plaza, como  así  también   proporcionar  esa  información  a  terceros  interesados.  Una  vez  cancelada la obligación en capital, gastos e intereses, la eliminación de dicho registro se realizará de acuerdo a los términos establecidos  en  la Ley 1682/01, sus modificaciones posteriores o la que regule ésta materia---------------------`;
        const longitudCorta = this.retornarLongitud(inicioX, finX, textWidth);
        const { textoCorto, textoRestante } = this.acortarPorPalabras(textoLargo, longitudCorta);
        this._doc.text(`${textoCorto}`, textWidth, 286);
        lines = this._doc.splitTextToSize(textoRestante, finX - inicioX); 
        cont = 0;
        yPosition = 296;
        for(const line of lines) {
            this._doc.text(line, inicioX, yPosition);            
            yPosition += lineHeight; 
        }
        this._doc.text('A todos los efectos legales, judiciales y extrajudiciales, fijamos domicilio en………………........……………………………………….….' , 38, 336);
        this._doc.text('…………………………........, que no podrá ser modificado sin comunicación escrita' , 38, 346);
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8.2);
        this._doc.text(` a ${operacion.nombre_entidad}`, 287, 346);
        this._doc.setFont("helvetica", "normal");
        this._doc.setFontSize(9);
        this._doc.text('Para  las  cuestiones  relacionadas  con  esta  obligación,  me/nos  someto/emos  a  la  jurisdicción  y  competencia  de los jueces y', 38, 356);
        this._doc.text('tribunales  de  la  ciudad  de  Asunción,  y  me/ nos serán notificadas en dicho domicilio la intimación de pago, la demanda y demás', 38, 366);
        this._doc.text('actuaciones , así como sentencias y resoluciones que recaigan en el procedimiento judicial------------------------------------------------------', 38, 376);
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(9);
        //firma primera parte
        this._doc.text('Firma _____________________________', 48, 406);
        this._doc.setFont("helvetica", "normal");
        let nombre = operacion.nombre_cliente ;
        if(operacion.documento_cliente === "x" || operacion.nombre_cliente === null) {
            nombre = '';
        }
        this._doc.text(`${nombre}`, 70, 420);
        this._doc.text(`${operacion.direccion ? operacion.direccion : ''}`, 94, 442);
        this._doc.text(`${operacion.nombre_barrio ? operacion.nombre_barrio : ''}`, 94, 456);
        this._doc.text(`${operacion.nombre_ciudad ? operacion.nombre_ciudad : ''}`, 98, 470); 
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(9);       
        this._doc.text('Deudor _____________________________', 43, 420);
        this._doc.text('Firma _____________________________', 282, 406);
        this._doc.text('Deudor _____________________________', 277, 420);
        this._doc.setFont("helvetica", "normal");
        this._doc.text('Calle', 74, 442);
        this._doc.line(70, 469, 70, 432);
        this._doc.setFontSize(9);
        this._doc.setFont("helvetica", "normal");
        this._doc.text('Barrio', 74, 456);
        this._doc.line(70, 459, 181, 459);
        this._doc.text('Ciudad', 74, 470);
        this._doc.line(70, 473, 181, 473);
        this._doc.setLineWidth(1);
        this._doc.line(38, 486, 181, 486);
        this._doc.setLineWidth(0.5);
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8);
        this._doc.text('DOMICILIO', 300, 469, { angle: 90 });
        this._doc.text('DOMICILIO', 68, 468, { angle: 90 });
        this._doc.line(70, 445, 181, 445);
        this._doc.line(302, 469, 302, 432);
        this._doc.setFontSize(9);
        this._doc.setFont("helvetica", "normal");
        this._doc.text('Calle', 306, 442);
        this._doc.line(303, 445, 418, 445);
        this._doc.text('Barrio', 306, 456);
        this._doc.line(303, 459, 418, 459);
        this._doc.text('Ciudad', 306, 470);
        this._doc.line(303, 473, 418, 473);
        this._doc.setLineWidth(1);
        this._doc.line(268, 486, 418, 486);
        //firma segunda parte
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(9);
        this._doc.text('Firma _____________________________', 48, 506);
        this._doc.text('Deudor _____________________________', 43, 520);
        this._doc.text('Firma _____________________________', 282, 506);
        this._doc.text('Deudor _____________________________', 277, 520);
        this._doc.setFont("helvetica", "normal");
        this._doc.setLineWidth(0.5);
        this._doc.text('Calle', 74, 542);
        this._doc.line(70, 545, 181, 545);
        this._doc.setFontSize(9);
        this._doc.setFont("helvetica", "normal");
        this._doc.text('Barrio', 74, 556);
        this._doc.line(70, 559, 181, 559);
        this._doc.text('Ciudad', 74, 570);
        this._doc.line(70, 573, 181, 573);
        this._doc.setLineWidth(0.5);
        this._doc.setFont("helvetica", "bold");
        this._doc.setFontSize(8);
        this._doc.text('DOMICILIO', 300, 569, { angle: 90 });
        this._doc.text('DOMICILIO', 68, 568, { angle: 90 });
        this._doc.line(70, 569, 70, 532);
        this._doc.line(302, 569, 302, 532);
        this._doc.setFontSize(9);
        this._doc.setFont("helvetica", "normal");
        this._doc.text('Calle', 306, 542);
        this._doc.line(303, 545, 418, 545);
        this._doc.text('Barrio', 306, 556);
        this._doc.line(303, 559, 418, 559);
        this._doc.text('Ciudad', 306, 570);
        this._doc.line(303, 573, 418, 573);

        this._doc.setProperties({
            title: "PAGARE A LA ORDEN"
        });
        window.open(URL.createObjectURL(this._doc.output('blob')));


    }
    // calculos para la elaboracion del pdf
    calcularTamanho(texto: string , tamanoLetra: number, posInicial: number) {
        return  Math.trunc(((this._doc.getStringUnitWidth(texto) * tamanoLetra ) / this._doc.internal.scaleFactor ) + posInicial);
    }

    retornarLongitud(inicio: number, fin: number, tamanho: number) {        
        return ((fin- inicio) - tamanho) / 2;
    }

    acortarPorPalabras(texto: string, longitudDeseada: number) {
        const palabras = texto.split(' ');
        let textoCorto = '';
        let textoRestante = '';
    
        for (let i = 0; i < palabras.length; i++) {
            if (textoCorto.length + palabras[i].length <= longitudDeseada) {
                textoCorto += palabras[i] + ' ';
            } else {
                textoRestante = palabras.slice(i).join(' ');
                break;
            }
        }
    
        return { textoCorto, textoRestante };
    }

    generarPdfComprobante( factura: any) {        
        const inicioX = 18;
        const finX = 430;
        this._doc.setFontSize(15);
        this._doc.setFont("helvetica", "normal")
        this._doc.text(`COMPROBANTE`, inicioX + 150 , inicioX + 5);
        let fontSize = this._doc.getFontSize();
        let textWidth = this.calcularTamanho('COMPROBANTE', fontSize, inicioX + 150)
        autoTable( this._doc, {
            startY: inicioX + 10,
            head: [[``]],
            headStyles: {  cellPadding: 4, minCellHeight: inicioX + 150, valign: 'middle'},
            theme: 'plain',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
                
            },
            margin:  { left: inicioX , right: finX, top: inicioX - 10 , bottom: 340 },
            tableWidth: 415,
        });
        let espacio = inicioX + 20 ;
        this._doc.setFont("helvetica", "bold")
        this._doc.setTextColor(69,81,181); 
        this._doc.setFontSize(10);
        this._doc.text('Datos Generales', inicioX + 15, espacio);
        this._doc.setTextColor(33,33,33); 
        this._doc.setFontSize(8);
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`DOCUMENTO:`, inicioX + 5 , espacio + 20);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('DOCUMENTO:', fontSize, inicioX + 5)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.documento_cliente ? factura.documento_cliente: '' }`, textWidth, espacio + 20)
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`NOMBRE:`, inicioX + 150 , espacio + 20);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('NOMBRE:', fontSize, inicioX + 150)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.nombre_cliente ? factura.nombre_cliente: '' }`, textWidth, espacio + 20)
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`NRO DE OPERACION:`, inicioX + 280 , espacio + 20);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('NRO DE OPERACION:', fontSize, inicioX + 280)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.nro_comprobante ? factura.nro_comprobante: '' }`, textWidth, espacio + 20)
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`CELULAR:`, inicioX + 5  , espacio + 40);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('CELULAR:', fontSize, inicioX + 5)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.celular ? factura.celular: '' }`, textWidth, espacio + 40)
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`CORREO:`, inicioX + 150 , espacio + 40);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('CORREO:', fontSize, inicioX + 150)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.correo ? factura.correo: '' }`, textWidth, espacio + 40)
        if ( factura.condicion_venta === 2 ) {
            this._doc.setFont("helvetica", "bold")
            this._doc.text(`PLAZO:`, inicioX + 280 , espacio + 40);
            fontSize = this._doc.getFontSize();
            textWidth = this.calcularTamanho('PLAZO:', fontSize, inicioX + 280)
            this._doc.setFont("helvetica", "normal")
            this._doc.text(` ${factura.plazo}`, textWidth, espacio + 40)
        }
        this._doc.setFont("helvetica", "bold")
        this._doc.setTextColor(69,81,181); 
        this._doc.setFontSize(10);
        this._doc.setLineWidth(0.5);
        this._doc.setDrawColor(228, 228, 228);
        this._doc.line(inicioX + 5, espacio + 50, finX - 5, espacio + 50);
        this._doc.line(inicioX + 5, espacio + 95, finX - 5, espacio + 95);
        this._doc.text('Otros Datos', inicioX + 15, espacio + 65);
        this._doc.setTextColor(33,33,33); 
        this._doc.setFontSize(8);
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`AGRUPACION:`, inicioX + 5 , espacio + 80);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('AGRUPACION:', fontSize, inicioX + 5)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.nombre_agrupacion ? factura.nombre_agrupacion: '' }`, textWidth, espacio + 80)
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`VENDEDOR:`, inicioX + 200 , espacio + 80);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('VENDEDOR:', fontSize, inicioX + 200 )
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.nombre_vendedor ? factura.nombre_vendedor: '' }`, textWidth, espacio + 80)
        this._doc.setFont("helvetica", "bold")
        this._doc.setTextColor(69,81,181); 
        this._doc.setFontSize(10);
        this._doc.text('Direccion ', inicioX + 15, espacio + 110);
        this._doc.setTextColor(33,33,33); 
        this._doc.setFontSize(8);
        this._doc.text(`DEPARTAMENTO:`, inicioX + 5 , espacio + 125);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('DEPARTAMENTO:', fontSize, inicioX + 5)
        this._doc.setFont("helvetica", "normal")
            this._doc.text(` ${factura.nombre_departamento ? factura.nombre_departamento: '' }`, textWidth, espacio + 125)
        
        this._doc.setFont("helvetica", "bold");
        this._doc.text(`CIUDAD:`, inicioX + 155 , espacio + 125);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('CIUDAD:', fontSize, inicioX + 155)
        this._doc.setFont("helvetica", "normal")
            this._doc.text(` ${factura.nombre_ciudad ? factura.nombre_ciudad: '' }`, textWidth, espacio + 125)
        
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`BARRIO:`, inicioX + 270 , espacio + 125);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('BARRIO:', fontSize, inicioX + 270)
        this._doc.setFont("helvetica", "normal")
            this._doc.text(` ${factura.nombre_barrio ? factura.nombre_barrio: '' }`, textWidth, espacio + 125)
        
        this._doc.setFont("helvetica", "bold")
        this._doc.text(`DIRECCION:`, inicioX + 5, espacio + 140);
        fontSize = this._doc.getFontSize();
        textWidth = this.calcularTamanho('DIRECCION:', fontSize, inicioX + 5)
        this._doc.setFont("helvetica", "normal")
        this._doc.text(` ${factura.direccion ? factura.direccion: '' }`, textWidth, espacio + 140);

        const tablaArticulo = 220;
        autoTable( this._doc, {
            startY: tablaArticulo,
            head: [[`ARTICULOS`]],
            headStyles: {   fontStyle: "bold", cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'white'},
            theme: 'plain',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0,
                fillColor: [21, 101, 192]
            },
            margin:  { left: inicioX , right: 410, top: 15, bottom: 5 },
            tableWidth: 415,
        });
        const articulos = factura.articulos;
        const articleRows = articulos.map(articlo => [
            articlo.codigo_articulo,
            articlo.nombre_articulo,
            articlo.cantidad, 
            this._decimalPipe.transform(  articlo.precio ),
            this._decimalPipe.transform(  articlo.total )
        ]);

        const arti = tablaArticulo + 15;

        autoTable(this._doc, {
            startY: arti,
            head: [['Articulo', 'Descripcion', 'Cantidad', 'Precio', 'Total']],
            headStyles: {fontStyle: "bold", cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
            body: articleRows,
            bodyStyles: {fillColor: 'white', lineColor: [228, 228, 228]},
            columnStyles: {
                0: {
                    halign: 'center'
                },
                1: {
                    halign: 'center'
                },
                2: {
                    halign: 'center'
                },
                3: {
                    halign: 'right'
                },
                4: {
                    halign: 'right'
                },
            },
            theme: 'plain',
            styles: {
                lineColor: [228, 228, 228],
                lineWidth: 0.5,
                fillColor: [0, 191, 191]
            },
            margin: { left: inicioX , right: 410, top: 15, bottom: 5 },
            tableWidth: 415,
        });
        const numRows = articleRows.length;
        const rowHeight = 15; // set the minimum height of each row
        const tableHeight = numRows * rowHeight;
        const tableEndY = arti + tableHeight;
        const formaPago = tableEndY + 30
        if(factura.condicion_venta === 1 ) {
            autoTable( this._doc, {
            startY: formaPago,
            head: [[`FORMAS DE PAGO`]],
            headStyles: {   fontStyle: "bold", cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'white'},
            theme: 'plain',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0,
                fillColor: [21, 101, 192]
            },
            margin:  { left: inicioX , right: 410, top: 15, bottom: 5 },
            tableWidth: 415,
            });

            const cobros = factura.cobros;
            const cobrosRows = cobros.map(cobro => [
                this._datePipe.transform( cobro.fecha_cobro, 'dd/MM/yyyy' ),
                cobro.nombre_forma_pago,
                cobro.trx_ref_cobro,
                cobro?.importe.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), 
            ]);

            const total = formaPago + 15;
            autoTable(this._doc, {
                startY:  total,
                head: [['Fecha Pago', 'Forma de Pago', 'Referencia', 'Importe']],
                headStyles: {fontStyle: "bold", cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
                body: cobrosRows,
                bodyStyles: {fillColor: 'white', lineColor: [228, 228, 228]},
                columnStyles: {
                    0: {
                        halign: 'center'
                    },
                    1: {
                        halign: 'center'
                    },
                    2: {
                        halign: 'center'
                    },
                    3: {
                        halign: 'right'
                    },
                },
                theme: 'plain',
                styles: {
                    lineColor: [228, 228, 228],
                    lineWidth: 0.5,
                    fillColor: [0, 191, 191]
                },
                margin: { left: inicioX , right: 410, top: 15, bottom: 5 },
                tableWidth: 415,
            });
            const cobro = cobrosRows.length;
            const roHeight = 15; // set the minimum height of each row
            const tableHeigh = cobro * roHeight;
            const EndY = total + tableHeigh;
            const totalY = EndY + 30;
            this._doc.setFontSize(10);
            this._doc.setFont("helvetica", "bold")
            
            this._doc.setTextColor(255,0,0)
            this._doc.text('TOTAL:', inicioX ,totalY );
            fontSize = this._doc.getFontSize();
            textWidth = this.calcularTamanho('TOTAL:', fontSize, inicioX );
            this._doc.setTextColor(10,10,10)
            this._doc.text(`  ${factura.importe_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`, textWidth, totalY );
            this._doc.setFontSize(10);
            this._doc.setFont("helvetica", "bold")
            this._doc.setTextColor(255,0,0)
            this._doc.text('SALDO:', finX - 50 ,totalY );
            fontSize = this._doc.getFontSize();
            textWidth = this.calcularTamanho('SALDO:', fontSize, finX - 50 );
            this._doc.setTextColor(10,10,10)
            this._doc.text(`  ${factura.saldo_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`, textWidth, totalY );
        } else {
            this._doc.setFontSize(10);
            this._doc.setFont("helvetica", "bold")
            this._doc.setTextColor(255,0,0)
            this._doc.text('TOTAL:', inicioX , formaPago );
            fontSize = this._doc.getFontSize();
            textWidth = this.calcularTamanho('TOTAL:', fontSize, inicioX );
            this._doc.setTextColor(10,10,10)
            this._doc.text(`  ${factura.importe_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`, textWidth, formaPago );
        }
        
        this._doc.setProperties({
            title: this._title
        });

        window.open(URL.createObjectURL(this._doc.output('blob')));
    }

    generarRendicionCaja(rendicionConsolidacion: Record<string,any>, tipo: number) {        
        const inicioX = 18;
        const finX = 430;
        const rendicionCaja = `RENDICION DE CAJA`;
        const consolidacion = `PERIODO   ${ this._datePipe.transform(rendicionConsolidacion.fecha_desde, 'dd/MM/yyyy')} A  ${ this._datePipe.transform(rendicionConsolidacion.fecha_hasta, 'dd/MM/yyyy')}`
        this._doc.setFontSize(15);
        this._doc.setFont("helvetica", "bold");
        let espacioConsolidado = 56; // para corregir el tamanho por si ingresa consolidado o rendicion normal
        const totalIngresos =  rendicionConsolidacion.ingresos.reduce( (accumulator, currentValue) => { return (accumulator + currentValue.monto)}, 0);
        const totalEgresos =  rendicionConsolidacion.egresos.reduce( (accumulator, currentValue) => { return (accumulator + currentValue.monto)}, 0);
        this.setHeader();
        /**
         * si es tipo 1 es RENDICION NORMAL por lo que se agrega el cajero y la fecha
         */        
        const marginHeader = { left: 12, right: 12, top: 20, bottom: 25 }
        if ( tipo === 1 ) {
            autoTable( this._doc, {
                startY: inicioX + 10,
                head: [[rendicionCaja]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'white'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#00bfbf'
                },
                margin: marginHeader,
                tableWidth: 422,
            });
            autoTable( this._doc, {
                startY: inicioX + 25,
                head: [[`CAJERO  ${rendicionConsolidacion.nombre_cajero}   FECHA: ${ this._datePipe.transform(rendicionConsolidacion.fecha_transaccion, 'dd/MM/yyyy')}`]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#f4f4f4'
                },
                margin: marginHeader,
                tableWidth: 422,
            });
            espacioConsolidado = espacioConsolidado + 25;
        } else {
            autoTable( this._doc, {
                startY: inicioX + 10,
                head: [[consolidacion]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#00bfbf', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'white'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#00bfbf'
                },
                margin: marginHeader,
                tableWidth: 422,
            });
        }

        let rendicionCajaIngreso = rendicionConsolidacion.ingresos.map(rendicion => [
                rendicion.nombre_concepto,
                this._decimalPipe.transform(  rendicion.monto )
            ]);
            
        autoTable( this._doc, {
            startY: espacioConsolidado,
            head: [[`INGRESOS`]],
            headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
            theme: 'plain',
            styles: {
                lineWidth: 0.5,
                fillColor: '#FFFFFF'
            },
            margin:  { left: inicioX , right: finX, top: inicioX - 10 , bottom: 340 },
            tableWidth: 200,
        });

        autoTable( this._doc, {
            startY: espacioConsolidado,
            head: [[`EGRESOS`]],
            headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
            theme: 'plain',
            styles: {
                lineWidth: 0.5,
                fillColor: '#FFFFFF'
            },
            margin:  { left: 230 , right: finX, top: inicioX - 10 , bottom: 340 },
            tableWidth: 200,
        });
        let espacioConceptoMonto = inicioX + 55;
        if ( tipo === 1 ) {
            espacioConceptoMonto = espacioConceptoMonto + 25;
        }

        autoTable( this._doc, {
            startY: espacioConceptoMonto,
            head: [[`Concepto`, 'Monto']],
            headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
            body: rendicionCajaIngreso,
            bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7},
            columnStyles: {
                0: {
                    halign: 'center'
                },
                1: {
                    halign: 'right'
                }
            },
            theme: 'plain',
            foot: [[{ content: `Total`, styles: { halign: 'left' } }, 
            { content:  this._decimalPipe.transform(  totalIngresos ), styles: { halign: 'right' } }]],
            footStyles: {fontSize: 8, fillColor: '#bdd8d8',  lineColor: '#e4e4e4'},
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
                
            },
            margin:  { left: inicioX , right: finX, top: inicioX - 10 , bottom: 340 },
            tableWidth: 200,
        }); 
        let rendicionCajaEgreso = rendicionConsolidacion.egresos.map(rendicion => [
                rendicion.nombre_concepto,
                this._decimalPipe.transform(  rendicion.monto )
            ]);            
        autoTable( this._doc, {
            startY: espacioConceptoMonto,
            head: [[`Concepto`, 'Monto']],
            headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
            body: rendicionCajaEgreso,
            bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7},
            theme: 'plain',
            foot: [[{ content: `Total`, styles: { halign: 'left' } }, 
            { content:  this._decimalPipe.transform(  totalEgresos ), styles: { halign: 'right' } }]],
            footStyles: {fontSize: 8, fillColor: '#bdd8d8', lineColor: '#e4e4e4'},
            columnStyles: {
                0: {
                    halign: 'center'
                },
                1: {
                    halign: 'right'
                }
            },
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
                
            },
            
            margin:  { left: 230 , right: finX, top: inicioX - 10 , bottom: 340 },
            tableWidth: 200,
        });
        /**
         * metodo para conseguir el tamanho de la tabla, se multiplica la longuitud del array por la longuitud de la celda 
         */
        
        if ( tipo === 2 ) {
            const fila = rendicionCajaEgreso.length;
            const rowHeight = 15; 
            const tablaAltura = fila * rowHeight;
            let tablafinalY =  inicioX + 20 + tablaAltura;
            autoTable( this._doc, {
                startY: tablafinalY + 64,
                head: [[`Valores`]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#FFFFFF'
                },
                margin:  { left: 230 , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: 200,
            });

            
            let otroValor = rendicionConsolidacion.otros_valores.map(valor => [
                valor.id_concepto,
                valor.nombre_concepto,
                this._decimalPipe.transform(  valor.monto )
            ]);   
            tablafinalY = inicioX + 36 + tablaAltura;
            autoTable( this._doc, {
                startY: tablafinalY + 64,
                head: [[`Codigo`, 'Concepto', 'Monto']],
                headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
                body: otroValor,
                bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7, halign: 'right'},
                theme: 'plain',
                    styles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    
                },
                columnStyles: {
                    0: {
                        halign: 'center'
                    },
                    1: {
                        halign: 'right'
                    }
                },
                foot: [[{ content: `Total`, styles: { halign: 'left' } }, '',
                { content:  this._decimalPipe.transform(  rendicionConsolidacion.detalle ), styles: { halign: 'right' } }]],
                footStyles: {fontSize: 8, fillColor: '#bdd8d8',  lineColor: '#e4e4e4'},
                margin:  { left: 230 , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: 200,
            });
    
            
        } else {
            const numRows = rendicionCajaIngreso.length > rendicionCajaEgreso.length ? rendicionCajaIngreso.length : rendicionCajaEgreso.length;
            const rowHeight = 15; // set the minimum height of each row
            const tableHeight = numRows * rowHeight;
            const tableEndY =  inicioX + 40 + tableHeight;  
            this._doc.setLineWidth(0.09);  
            this._doc.setDrawColor(205, 205, 205);
            this._doc.line(inicioX, tableEndY + 65, finX - 5, tableEndY + 64);
        }
        let numRows = rendicionCajaIngreso.length > rendicionCajaEgreso.length ? rendicionCajaIngreso.length : rendicionCajaEgreso.length;
        if ( tipo === 2 ) {
            numRows += rendicionConsolidacion.otros_valores.length ;
        }
        const rowHeight = 15; // set the minimum height of each row
        const tableHeight = numRows * rowHeight;
        let tableEndY =  inicioX + 40 + tableHeight;
        let resumen = tableEndY ;
        let anchoResumen = 415;
        let inicioResumen = inicioX;
        let otroValorTamano = resumen;
        if (tipo === 1 ) {
            resumen = tableEndY + 10 ;
            // resumen = tableEndY + 10;
            anchoResumen = 200;
            inicioResumen = 230;
            autoTable( this._doc, {
                startY: resumen + 64,
                head: [[`Otros Valores`]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#FFFFFF'
                },
                margin:  { left: inicioResumen , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: anchoResumen,
            });            
            let otroValor = rendicionConsolidacion.otros_valores.map(valor => [
                valor.nombre_concepto,
                this._decimalPipe.transform(  valor.monto )
            ]);   
            autoTable( this._doc, {
                startY: resumen + 79,
                head: [[`Concepto`, 'Monto']],
                headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
                body: otroValor,
                bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7, halign: 'right'},
                theme: 'plain',
                columnStyles: {
                    0: {
                        halign: 'center'
                    },
                    1: {
                        halign: 'right'
                    }
                },
                styles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    
                },
                foot: [[{ content: `Total`, styles: { halign: 'left' } },
                { content:  this._decimalPipe.transform(  rendicionConsolidacion.total_valores ), styles: { halign: 'right' } }]],
                footStyles: {fontSize: 8, fillColor: '#bdd8d8',  lineColor: '#e4e4e4'},
                margin: { left: inicioResumen , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: anchoResumen,
            });
            const numFila = numRows + rendicionConsolidacion.otros_valores.length;
            const rowHeight = 15; 
            const tableHeight = numFila * rowHeight;
            tableEndY =  inicioX + 28 + tableHeight;
            otroValorTamano = tableEndY ;
        }        
        autoTable( this._doc, {
            startY: (tipo === 2 ? otroValorTamano + 64 : otroValorTamano + 135),
            head: [[`RESUMEN`]],
            headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
            theme: 'plain',
            styles: {
                lineWidth: 0.5,
                fillColor: '#FFFFFF'
            },
            margin:  { left: inicioResumen , right: finX, top: inicioX - 10 , bottom: 15 },
            tableWidth: anchoResumen,
        });
        const tableEnd =   80 + resumen;
        const tamanhoY = tableEnd
        const marginTotales = { left: inicioResumen , right: finX, top: inicioX - 10 , bottom: 5 };
        if ( tipo === 1 ) {
            autoTable( this._doc, {
                startY: otroValorTamano + 150,
                head: [[`Saldo Anteriror`, 'Total Egresos', 'Total Ingresos', 'Detalle Valores', 'Saldo Actual']],
                headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'right', valign: 'middle'},
                body: [[this._decimalPipe.transform(  rendicionConsolidacion.saldo_anterior),  this._decimalPipe.transform(  rendicionConsolidacion.total_egresos ),  this._decimalPipe.transform(  rendicionConsolidacion.total_ingresos ),
                    this._decimalPipe.transform(  rendicionConsolidacion.total_valores ), this._decimalPipe.transform(  rendicionConsolidacion.saldo_actual )]],
                bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7, halign: 'right'},
                theme: 'plain',
                styles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    
                },
                
                margin: marginTotales,
                tableWidth: anchoResumen,
            });
        } else{
            autoTable( this._doc, {
                startY: tamanhoY,
                head: [[`Total Ingresos`, 'Total Egresos', 'Diferencia', 'Saldo Actual' ,'Detalle Valores', 'Faltante / Sobrante']],
                headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
                body: [[this._decimalPipe.transform(  rendicionConsolidacion.total_ingreso ),  
                    this._decimalPipe.transform(  rendicionConsolidacion.total_egreso ),  this._decimalPipe.transform(  rendicionConsolidacion.diferencia ),
                    this._decimalPipe.transform(  rendicionConsolidacion.saldo_actual ),
                    this._decimalPipe.transform(  rendicionConsolidacion.detalle ),
                    this._decimalPipe.transform(  rendicionConsolidacion.faltante_sobrante ),]],
                bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7, halign: 'right'},
                theme: 'plain',
                styles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    
                },
                
                margin: marginTotales,
                tableWidth: 415,
            });
        } 
        if ( tipo === 1 ) {
            autoTable( this._doc, {
                startY: resumen + 64,
                head: [[`Detalle de Efectivo`]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#FFFFFF'
                },
                margin:  { left: inicioX , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: 200,
            });
            let valorDetalle = rendicionConsolidacion.detalle_efectivo.map(valor => [
                valor.valor,
                valor.cantidad,
                this._decimalPipe.transform(  valor.monto )
            ]);
            autoTable( this._doc, {
                startY: tamanhoY,
                head: [['Valor', 'Cantidad', 'Monto']],
                headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
                body: valorDetalle,
                bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7, halign: 'right'},
                theme: 'plain',
                styles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    
                },
                foot: [[{ content: `Total`, styles: { halign: 'left' } }, '',
                { content:  this._decimalPipe.transform(  rendicionConsolidacion.total_efectivo ), styles: { halign: 'right' } }]],
                footStyles: {fontSize: 8, fillColor: '#bdd8d8',  lineColor: '#e4e4e4'},
                
                
                margin:  { left: inicioX , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: 200,
            });
            autoTable( this._doc, {
                startY: otroValorTamano + 196,
                head: [[`Faltante / Sobrante`]],
                headStyles: {   fontStyle: "bold", cellPadding: 4, lineColor: '#e4e4e4', minCellHeight: 15, halign: 'center', valign: 'middle', textColor: 'black'},
                theme: 'plain',
                styles: {
                    lineWidth: 0.5,
                    fillColor: '#FFFFFF'
                },
                margin:  { left: 230 , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: 200,
            });
            autoTable( this._doc, {
                startY: otroValorTamano + 211,
                head: [['Detalle Valores', 'Saldo Actual', 'Diferencia']],
                headStyles: {fontStyle: "normal", fillColor: '#00bfbf', lineColor: '#e4e4e4', cellPadding: 4, minCellHeight: 15, halign: 'center', valign: 'middle'},
                body: [[ this._decimalPipe.transform( rendicionConsolidacion.total_valores ),  this._decimalPipe.transform( rendicionConsolidacion.saldo_actual ),
                        this._decimalPipe.transform( rendicionConsolidacion.diferencia ) ]],
                bodyStyles: {fillColor: 'white', lineColor: '#e4e4e4', fontSize: 7, halign: 'right'},
                theme: 'plain',
                styles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    
                },
                
                margin:  { left: 230 , right: finX, top: inicioX - 10 , bottom: 15 },
                tableWidth: 200,
            });
        }
        this._doc.setProperties({
            title: "Listado Rendiciones"
        });
        window.open(URL.createObjectURL(this._doc.output('blob')));
    }
}

export interface IData {
    headers: IHeader[];
    source: ISource[];
    foot?: Record<string, any>;
}

export interface ISource { 
    data: Record<string, any>, 
    items?: { 
        headers: IHeader[],
        source: Record<string, any>[]
        foot?: Record<string, any>
    } 
};

export interface IHeader {
    label: string;
    name: string;
    type: string;
};

